import { render, staticRenderFns } from "./suppliersList.vue?vue&type=template&id=437d2c4b&scoped=true&"
import script from "./suppliersList.vue?vue&type=script&lang=js&"
export * from "./suppliersList.vue?vue&type=script&lang=js&"
import style0 from "./suppliersList.vue?vue&type=style&index=0&id=437d2c4b&lang=scss&scoped=true&"
import style1 from "./suppliersList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "437d2c4b",
  null
  
)

export default component.exports